import { useEffect, useState, useRef } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import style from "./style.scss";
import useDetectOutSideClick from "../../../../customHooks/useDetectOutSideClick";
import DropArrow from "../../../../assets/images/DropArrow.svg";
import TooltipArrow from "../../../../assets/images/TooltipArrow.svg";
import SyncLoader from "../../../../assets/images/SyncLoader.svg";
import ContentLoader from "../../../../components/Common/ContentLoader";
import { textIdentifier } from "../../../../components/Common/textIdentifier";

import { Mixpanel } from "../../../../Mixpanel";

const StudentTable = (props) => {
  const { language } = useSelector((state) => state.userSession.user);

  const {
    paramsSelectedClass,
    reportId,
    paramsSelectedChapter,
    studentList,
    handleSyncButton,
    getSubmittedCount,
    getNotStartedCount,
    selectStudentTest,
    setStudentList,
    disableTimer,
    redoEnabled,
    examReport,
    topicList,
    isTopicReport,
    setSelectedTopic,
  } = props;

  //   let isTopicReport = match.path.indexOf("topic-report") > -1;
  //   console.log(isTopicReport, paramsSelectedChapter, "isTopicReport");

  const { userSession } = useSelector((state) => state);

  //   const [studentList, setStudentList] = useState();
  const [dropdown, setDropdown] = useState(false);
  const [sortBy, changeSort] = useState("fname");
  const [topicDropDown, setTopicDropDown] = useState(false);

  useEffect(() => {
    if (!!examReport && !!examReport[reportId]) {
      let sortedStudents =
        sortBy == "fname"
          ? [...examReport[reportId]].sort((a, b) =>
              (a.firstName + "" + a.lastName).localeCompare(
                b.firstName + "" + b.lastName
              )
            )
          : sortBy == "lname"
          ? [...examReport[reportId]].sort((a, b) =>
              (a.lastName + "" + a.firstName).localeCompare(
                b.lastName + "" + b.firstName
              )
            )
          : sortBy == "low"
          ? [...examReport[reportId]].sort((a, b) =>
              a.score == "Not Started" ||
              a.score == "Deadline Missed" ||
              a.score == null
                ? 1
                : b.score == null ||
                  b.score == "Not Started" ||
                  b.score == "Deadline Missed"
                ? -1
                : a.score == "Yet to submit"
                ? -1
                : b.score == "Yet to submit"
                ? 1
                : a.score > b.score
                ? 1
                : b.score > a.score
                ? -1
                : 0
            )
          : [...examReport[reportId]].sort((a, b) =>
              a.score == "Not Started" ||
              a.score == "Deadline Missed" ||
              a.score == null
                ? 1
                : b.score == null ||
                  b.score == "Not Started" ||
                  b.score == "Deadline Missed"
                ? -1
                : a.score == "Yet to submit"
                ? 1
                : b.score == "Yet to submit"
                ? -1
                : a.score < b.score
                ? 1
                : b.score < a.score
                ? -1
                : 0
            );

      //[...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? -1 : b.score == "Yet to submit" ? 1 : (a.score > b.score) ? 1 : ((b.score > a.score) ? -1 : 0)) :
      // [...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? 1 : b.score == "Yet to submit" ? -1 : (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0))

      setStudentList([...sortedStudents]);
    }
  }, [examReport]);
  
  useEffect(() => {
    if (studentList && studentList.length > 0) {
      let sortedStudents =
        sortBy == "fname"
          ? [...examReport[reportId]].sort((a, b) =>
              (a.firstName + "" + a.lastName).localeCompare(
                b.firstName + "" + b.lastName
              )
            )
          : sortBy == "lname"
          ? [...examReport[reportId]].sort((a, b) =>
              (a.lastName + "" + a.firstName).localeCompare(
                b.lastName + "" + b.firstName
              )
            )
          : sortBy == "low"
          ? [...studentList].sort((a, b) =>
              a.score == "Not Started" ||
              a.score == "Deadline Missed" ||
              a.score == null
                ? 1
                : b.score == null ||
                  b.score == "Not Started" ||
                  b.score == "Deadline Missed"
                ? -1
                : a.score == "Yet to submit"
                ? -1
                : b.score == "Yet to submit"
                ? 1
                : a.score > b.score
                ? 1
                : b.score > a.score
                ? -1
                : 0
            )
          : [...studentList].sort((a, b) =>
              a.score == "Not Started" ||
              a.score == "Deadline Missed" ||
              a.score == null
                ? 1
                : b.score == null ||
                  b.score == "Not Started" ||
                  b.score == "Deadline Missed"
                ? -1
                : a.score == "Yet to submit"
                ? 1
                : b.score == "Yet to submit"
                ? -1
                : a.score < b.score
                ? 1
                : b.score < a.score
                ? -1
                : 0
            );
      setStudentList([...sortedStudents]);
      let sortType =
        sortBy == "high"
          ? "Score Descending"
          : sortBy == "low"
          ? "Score Ascending"
          : sortBy == "lname"
          ? "LastName"
          : "FirstName";
      Mixpanel.track("TeacherProduct_SortPerformed", {
        SortPerformedFrom: "ExamAnalytics",
        SortType: sortType,
      });
      // Mixpanel.people.set({
      // $email: userSession.user.email,
      // TeacherID: userSession.user.id,
      // });
      // console.log("sortedStudents",sortedStudents)
    }
  }, [sortBy]);


  //   const dispatch = useDispatch();
  const ref = useRef();
  const topicFilterRef = useRef();

  const timeConvert = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay =
      d > 0
        ? d +
          (d == 1
            ? textIdentifier["day"][language] + " "
            : textIdentifier["days"][language] + " ")
        : "";
    var hDisplay =
      h > 0
        ? h +
          (h == 1
            ? textIdentifier["hr"][language] + " "
            : textIdentifier["hr"][language] + " ")
        : "";
    var mDisplay =
      m > 0
        ? m +
          (m == 1
            ? textIdentifier["min"][language] + " "
            : textIdentifier["min"][language] + " ")
        : "";
    return !!seconds ? dDisplay + hDisplay + mDisplay : undefined;
  };

  const handleClickOutside = () => {
    setDropdown(false);
    // setTopicDropDown(false);
  };
  const handleClickOutsideTopicFilter = () => {
    setTopicDropDown(false);
  };
  useDetectOutSideClick(ref, handleClickOutside);
  useDetectOutSideClick(topicFilterRef, handleClickOutsideTopicFilter);

  return (
    <div className={style["test--students"]}>
      {
        <>
          <div className={style["score-table"]}>
            <div className={style["table-m-header"]}>
              <div className={style["navigator"]}>
                {textIdentifier["student-list"][language]}
              </div>
              <div
                className={[
                  style["table-sync-button"],
                  !studentList ? style["loading"] : "",
                ].join(" ")}
                onClick={handleSyncButton}
              >
                <div className={style["table-sync-icon"]}>
                  <img src={SyncLoader} alt="" />
                </div>
                {textIdentifier["sync"][language]}
              </div>
            </div>
            {!!studentList && !isTopicReport && (
              <div className={style["table-m-sub-header"]}>
                {studentList.length}{" "}
                {textIdentifier["students-are-in-this-class"][language]}.{" "}
                {getSubmittedCount(studentList)}{" "}
                {textIdentifier["students-submitted-the-test-and"][language]}{" "}
                {getNotStartedCount(studentList)}{" "}
                {
                  textIdentifier["students-have-not-started-the-test-yet"][
                    language
                  ]
                }
              </div>
            )}
            {/* {
              console.log(topicList, "topicList")
              {
                  "347": {
                      "id": 347,
                      "name": "Quadratic Expressions",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": "https://assessment-download-htmls-new.s3.ap-southeast-1.amazonaws.com/8087cb51-0aa4-4790-989b-b8d3a278ad1b.pdf"
                  },
                  "366": {
                      "id": 366,
                      "name": "Quadratic Equation2",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": null
                  },
                  "2002": {
                      "id": 2002,
                      "name": "Sutd Week6 Ct",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": null
                  },
                  "6295": {
                      "id": 6295,
                      "name": "Mcq And Multiple Correct Mcqs Topic By Mukesh 2",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": null
                  },
                  "14034": {
                      "id": 14034,
                      "name": "Testing Pissa Science Pedagogy",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": null
                  },
                  "14052": {
                      "id": 14052,
                      "name": "Dev Theme One Pisa Questions",
                      "isPublished": true,
                      "timelines": {},
                      "googleClassroomLink": null,
                      "topicContentLink": null
                  }
              }
            } */}
            {topicList && Object.keys(topicList).length > 0 && (
              <div className={style["topic-filter"]}>
                <div
                  className={style["topic-filter--selected"]}
                  onClick={() => {
                    setTopicDropDown(!topicDropDown);
                  }}
                >
                  <div className={style["topic-filter--selected-text"]}>
                    {topicList[reportId]?.name}
                  </div>
                  <img src={DropArrow} alt="v" className={style["drop--img"]} />
                </div>
                {topicDropDown && <div className={style["select--dropdown"]} ref={topicFilterRef}>
                  {Object.keys(topicList).map((topicId) => {
                    return (
                      <div
                        className={style["drop-ele"]}
                        key={topicId}
                        onClick={() => {
                          setSelectedTopic(topicId);
                          setTopicDropDown(false);
                          // handleClickOutside();
                        }}
                      >
                        {topicList[topicId]?.name}
                      </div>
                    );
                  }
                  )}
                </div>}
              </div>
            )}
            <div className={style["table-header"]}>
              <div
                class={[
                  style["student-name"],
                  style[isTopicReport && "wider"],
                ].join(" ")}
              >
                {textIdentifier["student-name"][language]}
                <div className={style["student--sorting"]} ref={ref}>
                  <div
                    className={style["sort--selected"]}
                    onClick={() => {
                      setDropdown(!dropdown);
                    }}
                  >
                    <div>
                      {sortBy == "low"
                        ? textIdentifier["sort-by-score"][language] +
                          " " +
                          textIdentifier["(ASC)"][language]
                        : sortBy == "high"
                        ? textIdentifier["sort-by-score"][language] +
                          " " +
                          textIdentifier["(DESC)"][language]
                        : sortBy == "fname"
                        ? textIdentifier["sort-by-first-name"][language]
                        : textIdentifier["sort-by-last-name"][language]}
                    </div>
                    <img
                      src={DropArrow}
                      alt="v"
                      className={style["drop--img"]}
                    />
                  </div>
                  <div className={style["select--dropdown"]}>
                    {dropdown && (
                      <>
                        {sortBy != "fname" && (
                          <div
                            className={style["drop-ele"]}
                            key={"fname"}
                            onClick={() => {
                              handleClickOutside();
                              changeSort("fname");
                            }}
                          >
                            {textIdentifier["sort-by-first-name"][language]}
                          </div>
                        )}
                        {sortBy != "lname" && (
                          <div
                            className={style["drop-ele"]}
                            key={"lname"}
                            onClick={() => {
                              handleClickOutside();
                              changeSort("lname");
                            }}
                          >
                            {textIdentifier["sort-by-last-name"][language]}
                          </div>
                        )}
                        {!isTopicReport && sortBy != "low" && (
                          <div
                            className={style["drop-ele"]}
                            key={"low"}
                            onClick={() => {
                              handleClickOutside();
                              changeSort("low");
                            }}
                          >
                            {textIdentifier["sort-by-score"][language]}{" "}
                            {textIdentifier["(ASC)"][language]}
                            {/* {textIdentifier["low-to-high-score"][language]} */}
                          </div>
                        )}
                        {!isTopicReport && sortBy != "high" && (
                          <div
                            className={style["drop-ele"]}
                            key={"high"}
                            onClick={() => {
                              handleClickOutside();
                              changeSort("high");
                            }}
                          >
                            {textIdentifier["sort-by-score"][language]}{" "}
                            {textIdentifier["(DESC)"][language]}
                            {/* {textIdentifier["high-to-low-score"][language]} */}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {!isTopicReport && (
                <div class={style["student-score"]}>
                  {textIdentifier["score"][language]}
                </div>
              )}
              <div class={style["student-attempted"]}>
                {textIdentifier["question-attempted"][language]}
              </div>
              <div class={style["student-solved"]}>
                {textIdentifier["correctly-solved"][language]}
              </div>
              <div class={style["student-wrong"]}>
                {textIdentifier["wrong-attempt"][language]}
              </div>
              {!disableTimer && (
                <div class={style["student-time"]}>
                  {textIdentifier["time-taken"][language]}
                </div>
              )}
              {/* { <div class={style["student-time"]}>{textIdentifier["time-taken"][language]}</div>} */}
              {!redoEnabled && (
                <div class={style["student-action"]}>
                  {textIdentifier["action"][language]}
                  <div className={style["action-i-btn"]}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.5 7.5L7.52733 7.48667C7.61282 7.44396 7.70875 7.42664 7.80378 7.43677C7.8988 7.4469 7.98893 7.48404 8.0635 7.54381C8.13806 7.60357 8.19394 7.68345 8.22451 7.77399C8.25508 7.86453 8.25907 7.96193 8.236 8.05467L7.764 9.94533C7.74076 10.0381 7.74463 10.1356 7.77513 10.2263C7.80563 10.3169 7.86149 10.3969 7.93609 10.4568C8.01069 10.5166 8.10089 10.5538 8.196 10.564C8.2911 10.5741 8.38712 10.5568 8.47267 10.514L8.5 10.5M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8ZM8 5.5H8.00533V5.50533H8V5.5Z"
                        stroke="#3185FC"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div className={style["i-tooltip-box"]}>
                      {
                        textIdentifier[
                          "here-you-allow-student-to-reset-test-and-(n)-represent-number-of-times-you-have-allowed-this-student-to-reset-this-test"
                        ][language]
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={style["table-container"]}>
              {/* {console.log("studentList",studentList)} */}
              {!!studentList ? (
                <>
                  {studentList.map((student, index) => {
                    return (
                      <div
                        className={[
                          style["table-row"],
                          style[
                            isTopicReport ||
                            student.status == "Not Started" ||
                            student.status == "Deadline Missed" ||
                            student.status == "Yet to submit" ||
                            (student.status == "AI Evaluating" &&
                              !student.attemptOrder)
                              ? "table-disabled"
                              : ""
                          ],
                        ].join(" ")}
                        onClick={() =>
                          isTopicReport ||
                          student.status == "Not Started" ||
                          student.status == "Deadline Missed" ||
                          student.status == "Yet to submit" ||
                          (student.status == "AI Evaluating" &&
                            !student.attemptOrder)
                            ? ""
                            : selectStudentTest(student)
                        }
                      >
                        {/* {console.log(
                          student.status,
                          "boolean",
                          student.status == "Not Started" ||
                            student.status == "Deadline Missed" ||
                            student.status == "Yet to submit"
                        )} */}
                        <div className={style["username-tooltip"]}>
                          <div className={style["username-head"]}>
                            {textIdentifier["username"][language]}
                          </div>
                          <div className={style["username-main"]}>
                            {student.username}
                          </div>
                          <div className={style["username-head"]}>
                            {textIdentifier["name"][language]}
                          </div>
                          <div className={style["username-main"]}>
                            {student.showLastNameFirst
                              ? (student.lastName ? student.lastName : "") +
                                " " +
                                (student.firstName ? student.firstName : "")
                              : (student.firstName ? student.firstName : "") +
                                " " +
                                (student.lastName ? student.lastName : "")}
                          </div>
                        </div>
                        <div className={style["username-tooltip-arrow"]}>
                          <img src={TooltipArrow} alt="" />
                        </div>
                        <div
                          class={[
                            style["student-name"],
                            style["student-sec-name"],
                            style[isTopicReport && "wider"],
                          ].join(" ")}
                        >
                          <div className={style["name-cont"]}>
                            {student.showLastNameFirst
                              ? (student.lastName ? student.lastName : "") +
                                " " +
                                (student.firstName ? student.firstName : "")
                              : (student.firstName ? student.firstName : "") +
                                " " +
                                (student.lastName ? student.lastName : "")}
                          </div>
                          {/* <div className={style["username-tooltip"]}>
                            <div className={style["username-head"]}>username</div>
                            <div className={style["username-main"]}>{student.username}</div>
                            <div className={style["tooltip-arrow"]}>
                              <img src={TooltipArrow} alt="" />
                            </div>
                          </div> */}
                          {student.status && (
                            <div
                              className={
                                student.status == "Not Started"
                                  ? style["not-started"]
                                  : student.status == "Completed"
                                  ? style["completed"]
                                  : student.status === "AI Evaluating"
                                  ? style["ai-evaluating"]
                                  : style["inactive"]
                              }
                            >
                              {student.statusText
                                ? student.statusText
                                : student.status}
                            </div>
                          )}
                        </div>
                        <div class={[style["student-score"]].join(" ")}>
                          {student.score}
                          {student.attemptOrder && (
                            <span>
                              ({textIdentifier["attempt"][language]}{" "}
                              {student.attemptOrder})
                            </span>
                          )}
                        </div>
                        <div class={style["student-attempted"]}>
                          {student.questionsAttempted != null && student.questionsAttempted != undefined 
                            && student.questionsAttempted
                          }

                        </div>
                        <div class={style["student-solved"]}>
                          {student.correct != null && student.correct != undefined
                            && student.correct
                          }
                        </div>
                        <div class={style["student-wrong"]}>
                          {student.wrong != null && student.wrong != undefined
                            && student.wrong
                          }
                        </div>
                        {!disableTimer && (
                          <div class={style["student-time"]}>
                            {timeConvert(student.timeTaken)}
                          </div>
                        )}
                        {/* {selectedTest &&
                          !selectedTest.redoEnabled && (
                            student.resetCount != undefined ||
                              student.resetCount != null
                          ) && (
                            <div class={style["student-action"]}>
                              <div
                                className={style["action-reset-btn"]}
                                onClick={(e) => {e.stopPropagation(); handleModalClick(true, student)}}
                              >
                                {textIdentifier["reset-test"][language]}(
                                {student.resetCount})
                              </div>

                              
                            </div>
                          )} */}
                      </div>
                    );
                  })}
                </>
              ) : (
                <ContentLoader />
              )}
            </div>
          </div>
        </>
      }
    </div>
  );
};

export default StudentTable;
